import { createFileRoute } from "@tanstack/react-router";
import { Nav } from "@/components/landing/nav";
import { Hero } from "@/components/landing/hero";
import { Marquee } from "@/components/landing/marquee";
import { Services } from "@/components/landing/services";
import { Trust } from "@/components/landing/trust";
import { Features } from "@/components/landing/features";
import { Audience } from "@/components/landing/audience";
import { FAQ } from "@/components/landing/faq";
import { Footer } from "@/components/landing/footer";

export const Route = createFileRoute("/")({
	component: Home,
});

function Home() {
	return (
		<div className="overflow-x-hidden">
			<Nav />
			<Hero />
			{/* Visually-hidden SEO strip — screen-reader accessible, keyword-rich */}
			<h2 className="sr-only">
				Proxi is an on-demand errand service in Lagos, Nigeria. Book grocery
				delivery, pharmacy runs, document pickup, queue standing, food runs,
				parcel delivery, bank runs, school runs, airport pickups, and
				confidential errands across Lekki, Victoria Island, Ikoyi, Yaba,
				Surulere, Ajah, Ikeja, Lagos Island, Gbagada, Magodo, Maryland, Festac,
				and Ogudu. Every errand is protected by escrow and handled by a verified
				runner near you.
			</h2>
			<Marquee />
			<Services />
			<Trust />
			<Features />
			<Audience />
			<FAQ />
			<Footer />
		</div>
	);
}
